import styled from 'styled-components';

import { theme } from '../layout/theme';
import { size } from '../layout/helpers';

export const SliderContainer = styled.div`
  position: relative;

  ${theme.screens.LtMd} {
    &:not(.in-panel) {
      margin: 0 ${size(-2)};
    }
    &.in-panel {
      margin: 0 auto;
      max-width: 100%;
      max-height: 30vh;
      width: calc(30vh * 1.426); // aspect ratio of images in box
    }
  }

  ${theme.screens.Md} {
    padding: 0 ${size(5)};

    &.in-panel {
      margin: 0 ${size(5)};
    }
  }
`;

export const Slider = styled.div`
  display: flex;
  align-items: center;
  overflow: auto;

  /* Hide scrollbar for Chrome, Safari and Opera */
  &::-webkit-scrollbar {
    -webkit-appearance: none;
    display: none;
    height: 0;
  }

  /* Hide scrollbar for IE, Edge add Firefox */
  -ms-overflow-style: none;
  scrollbar-width: none; /* Firefox */

  ${theme.screens.LtMd} {
    scroll-padding-left: ${size(3)};
    scroll-padding-right: ${size(3)};
    scroll-snap-type: x mandatory;

    &:after {
      content: '';
      flex: 0 0 ${size(3)};
    }
  }

  ${theme.screens.Md} {
    overflow: auto;

    @supports (-moz-appearance: none) {
      overflow: hidden;
    }
  }
`;

export const SliderItem = styled.div`
  cursor: pointer;
  flex: 0 0 calc(100% - ${size(6)});
  margin: 0 ${size(3)};

  ${theme.screens.LtMd} {
    scroll-snap-align: start;
    &:last-child {
      margin-right: 0;
    }
  }

  ${theme.screens.Md} {
    flex-basis: calc(100% - 2px);
    margin: 0 1px;
  }
`;

export const SliderControls = styled.div``;

const Control = styled.button`
  position: absolute;
  top: calc(50% - 6px);
  font-size: 24px;

  ${theme.screens.LtMd} {
    display: none;
  }
`;

export const ControlLeft = styled(Control)`
  left: 0;
`;

export const ControlRight = styled(Control)`
  right: 0;
`;
